/** משתמשים חיצוניים — אין גישה ל-API הודעות; חוסם קריאות לפני שה-role מגיע ל-AppHeader. */
let messagingAccessBlocked = false;

export function setMessagingAccessBlocked(blocked: boolean): void {
  messagingAccessBlocked = blocked;
}

export function isMessagingAccessBlocked(): boolean {
  return messagingAccessBlocked;
}
